import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Button from 'Components/Shared/Button/Button'
import { addOutput, OutputTypes } from 'redux/reducers/output/outputSlice'
import { CardItem } from 'types'
import CardGroup from '../CardGroup/CardGroup'
import StoreBanner from '../../../Shared/StoreBanner/StoreBanner'
import { StorePageStyle } from './StorePageStyle'

export interface StorePageProps {
  bannerName?: string
  bannerLogoSrc?: string
  introText?: string
  footerText?: string
  hidePrice?: boolean
  showCancelButton?: boolean
  purchaseButtonText?: string
  items: CardItem[]
  onCancel?: () => void
  onSelect: (id: string) => void
  cancelButtonText?: string
}

const StorePage: FC<StorePageProps> = ({
  bannerLogoSrc,
  bannerName,
  introText,
  footerText,
  hidePrice,
  showCancelButton,
  purchaseButtonText,
  items,
  onCancel,
  onSelect,
  cancelButtonText,
}) => {
  if (showCancelButton && !onCancel) {
    throw new Error(
      'OnCancel function is undefined when showCancelButton is provided'
    )
  }

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(
      addOutput({
        key: OutputTypes.itemOrderShown,
        value: items.map((item) => item.id).toString(),
      })
    )

    dispatch(
      addOutput({
        key: OutputTypes.numberOfItemsShown,
        value: String(items.length),
      })
    )
  }, [dispatch, items])

  return (
    <StorePageStyle>
      <StoreBanner name={bannerName} logoSrc={bannerLogoSrc} />
      {introText && (
        <div
          className="introText"
          dangerouslySetInnerHTML={{ __html: introText }}
        />
      )}
      <CardGroup
        items={items}
        hidePrice={hidePrice}
        onSelect={onSelect}
        purchaseButtonText={purchaseButtonText}
      />
      {footerText && (
        <div
          className="footerText"
          dangerouslySetInnerHTML={{ __html: footerText }}
        />
      )}
      {showCancelButton && (
        <Button
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          onClick={onCancel!}
        >
          {cancelButtonText || "I Don't Want Any Of These Options"}
        </Button>
      )}
    </StorePageStyle>
  )
}

export default StorePage
